import React from 'react';

import Glyphicon from 'react-bootstrap/lib/Glyphicon';


const Spinner = () => <Glyphicon glyph="refresh" className="spinner" />;

export default Spinner;
